import React from 'react';
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/dexy.jpg";
import projImg2 from "../assets/img/proj2.jpg";
import projImg3 from "../assets/img/proj3.jpg";
import projImg4 from "../assets/img/proj4.jpg";
import projImg5 from "../assets/img/proj5.jpg";
import projImg6 from "../assets/img/proj6.jpg";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title: "Dexy",
      description: "AI Chatbot For Depression & Anixiety",
      imgUrl: projImg1,
    },
    {
      title: "Simple Password Manager",
      description: "A Simple Password Manager on Python and PostgreSQL",
      imgUrl: projImg2,
    },
    {
      title: "Finder Browser",
      description: "A Browser App on Flutter",
      imgUrl: projImg3,
    }
  ];

  const projects2 = [
    {
      title: "Space Clash",
      description: "Space Clash Game on Pyhton",
      imgUrl: projImg4,
    },
    {
      title: "Simple Pandas Project",
      description: "A  Simple Database project using python and pandas. ",
      imgUrl: projImg5,
    },
    {
      title: "Aimfit",
      description: "Fitness App on Python",
      imgUrl: projImg6,
    }
  ];

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p>Venturing into the realm of creative exploration, I proudly present a collection of my diverse projects. Embracing the spirit of innovation, I constantly strive to push boundaries and challenge conventions. Delve into this showcase of my work, where you'll find a glimpse of the unique endeavors that reflect my commitment to doing things differently.</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Tab 1</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Tab 2</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Tab 3</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                      <p>Kindly visit <a href="https://github.com/MHaseeb02" target="_blank" rel="noopener noreferrer">Github</a> to have access to the mentioned projects!</p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                    <Row>
                        {
                          projects2.map((project2, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project2}
                                />
                            )
                          })
                        }
                      </Row>
                      <p>Kindly visit <a href="https://github.com/MHaseeb02" target="_blank" rel="noopener noreferrer">Github</a> to have access to the mentioned projects!</p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <p>Comming Soon!.</p>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>
}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
